(function() {

  class Masterminds {
    constructor(element) {
      if(!element || element.classList.contains('u-module--initialized')) return;

      element.classList.add('u-module--initialized');

      this.modal = element.querySelector('.u-masterminds__modal');
      this.modalQuote = this.modal.querySelector('.u-masterminds__modal-quote');
      this.modalName = this.modal.querySelector('.u-masterminds__modal-name');
      this.modalDescription = this.modal.querySelector('.u-masterminds__modal-description');
      this.buttons = element.querySelectorAll('.u-masterminds__button');

      this.element = element;
      this.init();
    }

    init() {

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.openModal(button.closest('.u-masterminds__item'));
        })
      })

      const closeButton = this.element.querySelector('.u-masterminds__modal-close-button');
      closeButton.addEventListener('click', () => {
        this.closeModal();
      })
    }

    openModal(item) {

      this.modalQuote.innerHTML = item.dataset.quote;
      this.modalName.innerHTML = item.dataset.name;
      this.modalDescription.innerHTML = item.dataset.description;

      const otherItems = Array.prototype.slice.call(document.querySelectorAll('.u-masterminds__item')).filter((i) => i != item);
      let tl = gsap.timeline({
        onComplete: () => {
          
        }
      });
      this.modal.style.display = 'block';
      tl.addLabel("start")
        .to(otherItems, {opacity: .3, duration: .5})
        .fromTo(this.buttons, {opacity: 1, scale: 1 }, {opacity: 0, duration: .5, scale: 0}, "-=.5")
        .fromTo(this.modal, {opacity: 0, scale: 0 }, {opacity: 1, duration: .5, scale: 1}, "-=.5")
        .addLabel("end");
    }

    closeModal() {
      let tl = gsap.timeline({
        onComplete: () => {
          // this.modal.style.display = 'none';
        }
      });
      tl.addLabel("start")
        .fromTo(this.modal, {opacity: 1, scale: 1 }, {opacity: 0, duration: .5, scale: 0})
        .fromTo(this.buttons, {opacity: 0, scale: 0 }, {opacity: 1, duration: .5, scale: 1}, "-=.5")
        .to(this.element.querySelectorAll('.u-masterminds__item'), {opacity: 1, duration: .5}, "-=.5")
        .addLabel("end");
    }

  }

  function initAll(parent) {
    const elements = parent.querySelectorAll('.u-masterminds');

    for (const element of elements) {
      new Masterminds(element)
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });
  
  document.addEventListener('overlay-content-ready', function () {
    initAll(document.querySelector('.u-overlay__content'));
  });

})();